import useAcordos from "features/acordo/hooks/useAcordos";
import useTotalDashboard from "features/unidades/dashboard/useTotalDashboard";
import CollapsibleListCard from "../CollapsibleListCard";
import useAcordoCardColumns from "./../../hooks/useAcordoCardColumns";
import history from "infra/helpers/history";
import { AcordoItem } from "core/features/acordo/typings";

function CardAcordos({ unidadeId }: { unidadeId: string }) {
  const { data, isLoading } = useTotalDashboard(
    `/v1/unidades/dashboard/${unidadeId}/total-acordos`
  );

  return (
    <CollapsibleListCard
      value={data?.total ?? 0}
      isLoading={isLoading}
      unidadeId={unidadeId}
      singularTitleText="histórico de acordo"
      getDataHook={useAcordos}
      useColumnsHook={useAcordoCardColumns}
      onRow={(v: AcordoItem) => ({
        onClick: () => {
          history.push(`/financeiro/receita/acordo/${v.id}`);
        },
        style: {
          cursor: "pointer",
        },
      })}
    />
  );
}

export default CardAcordos;
